import React from "react" // eslint-disable-line no-unused-vars
import injectSheet from "react-jss"
import cn from "classnames"
import { color } from "@xingternal/360-styles/helpers"
import { Line } from "react-chartjs-2"
import setOptions from "../chartOptions"
import { onlyfyFullTheme } from "@xingternal/rebranding-adapter"

const styles = { container: { height: ({ height }) => height } }

const defaultDatasetOptions = {
  backgroundColor: "rgba(60,92,157,0.2)", // `blue 8 / linkText` in `rgba()` to allow transparency (brandguide.new-work.se)
  borderCapStyle: "butt",
  borderColor: onlyfyFullTheme.colors.linkText,
  borderWidth: 1,
  fill: true,
  lineTension: 0,
  pointBackgroundColor: onlyfyFullTheme.colors.linkText,
  pointBorderColor: "#fff",
  pointBorderWidth: 1,
  pointHitRadius: 4,
  pointHoverBackgroundColor: onlyfyFullTheme.colors.linkText,
  pointHoverBorderColor: "#fff",
  pointHoverBorderWidth: 2,
  pointHoverRadius: 6,
  pointRadius: 3,
  pointStyle: "circle",
}

const parseData = (payload) => {
  payload.datasets.forEach((dataset, i) => {
    payload.datasets[i] = { ...defaultDatasetOptions, ...dataset }
  })

  return payload
}

const LineChart = ({ className, classes, data, height, options }) => (
  <div className={cn(classes.container, className)}>
    <Line
      data={parseData(data)}
      options={setOptions(options)}
      height={height}
    />
  </div>
)

LineChart.defaultProps = {
  height: 280,
  classes: {},
}

export const StyledLineChart = injectSheet(styles)(LineChart)
export default LineChart
